<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5
    
    .titulo-principal(data-aos="flip-up")
      .titulo-principal__numero
        span 4
      h1 Análisis de los procesos a nivel de negocio
    .row.bg-color6.px-5
      .col-12.mt-5
        .row.mb-4
          .col-lg-7
            .row
              .col-12.bg-color11
                p.mb-0 Con base en los conceptos de la teoría general de sistemas y partiendo de la visión del todo se debe comprender el funcionamiento real a partir de desestructurar ese todo en procesos, subprocesos, relaciones y actores que intervienen con el objetivo de identificar, comprender, evaluar y resolver problemas que ayudan a las instituciones a mejorar dichos procesos, reformar las opciones de negocio y brindar a sus consumidores a experimentar una mejor calidad de productos o servicios. Por esto, es necesario que realicen de manera constante, frecuente y repetitiva un análisis de sus procesos de negocio desde la TGS donde visualicen y comprendan cada uno de los pormenores que transforman el negocio con el objetivo de mejorar sus operaciones y el servicio al cliente. A continuación, una breve información al respecto:
          .col-lg-5
            figure(data-aos="fade-left")
              img(src='@/assets/curso/img5.png', style="width: 450px").m-auto
        .row
          .col-12
            figure
              img(src='@/assets/curso/img1.gif', style="width: 1200px").m-auto
    .row.my-5
      .col-lg-4.mb-4.mb-lg-0
        figure(data-aos="fade-right")
          img(src='@/assets/curso/img15.svg', style="width: 450px").m-auto
      .col-lg-8
        p Una de las técnicas que permite conseguir estos objetivos es el análisis de procesos de negocio que significa llegar al conocimiento detallado de cada labor y que se hace abordando la operación central de valor hasta las que pueden considerarse como labores rama o periféricas no menos importantes. Ese es el nombre que se le da a la acción que realizan las organizaciones para revisar, documentar y entender sus procesos.
        p Tiene como objetivo el desglose de cada uno de los componentes en cada proceso como:
        ul.lista-ul.ms-3
          li 
            i.fab.fa-buffer(style="color:#039BE5;")
            | Entradas.
          li 
            i.fab.fa-buffer(style="color:#039BE5;")
            | Salidas.
          li 
            i.fab.fa-buffer(style="color:#039BE5;")
            | Procedimientos.
          li 
            i.fab.fa-buffer(style="color:#039BE5;")
            | Controles.
          li 
            i.fab.fa-buffer(style="color:#039BE5;")
            | Aplicaciones.
          li 
            i.fab.fa-buffer(style="color:#039BE5;")
            | Datos.
    p.mb-5 Es importante, comprender las acciones que integran cada uno de los siguientes elementos:
    .row.justify-content-center.mb-5
      .col-lg-10
        .titulo-sexto.color-acento-contenido
          h5 Figura 5
          p.mb-0 Acciones para el análisis
        figure(data-aos="fade-left")
          img(src='@/assets/curso/img16.svg', style="width: 550px").m-auto
    p.mb-5 A continuación, se explica de manera detallada cada proceso:
    #t_4_1
    .titulo-segundo
      h2 4.1  Identificar los procesos
    p.mb-5 Para realizar una excelente identificación de procesos se recomienda realizar las siguientes actividades en dos escenarios:
    ol.lista-ol--cuadro.lista-ol--separador.mb-5
      li 
        .lista-ol--cuadro__vineta
          span 1
        |
        .row.align-items-center
          .col-lg-8.mb-4.mb-lg-0
            p.mb-0 #[b Antes]: se debe obtener acceso de información sobre la organización, para antes de llegar a esta, se investigue sobre el contexto de negocio en el que se mueve la empresa. Por ejemplo: determinar si se está hablando de un banco o una empresa de energía o una empresa que presta servicios y en ese caso qué tipo de servicios presta o por el contrario si es una empresa que fabrica productos, que productos fabrica es decir que hace. Conocer de ella también sus sedes (instalaciones físicas).
          .col-lg-4
            figure(data-aos="fade-left")
              img(src='@/assets/curso/img6.png', style="width: 450px").m-auto
      li 
        .lista-ol--cuadro__vineta
          span 2
        |
        .row.align-items-center
          .col-lg-8.mb-4.mb-lg-0
            p Cuando exista cercanía, acceso o contacto con la entidad, planear entonces la recolección de información aplicando las técnicas que existen para ello como lo es:
            .row
              .col-12
                ul.lista-ul.ms-3
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Método de la observación.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | La elaboración de formatos de encuestas.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | El enfoque de trabajo (#[i focus group]).
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Las entrevistas.
          .col-lg-4
            figure(data-aos="fade-left")
              img(src='@/assets/curso/img7.png', style="width: 450px").m-auto
    .row.align-items-center.mb-5
      .col-lg-5.mb-4.mb-lg-0
        figure(data-aos="fade-right")
          img(src='@/assets/curso/img17.svg', style="width: 550px").m-auto
      .col-lg-7
        .cajon.color-primario.p-4.mb-4
          p.mb-0 Como resultado de estas técnicas se deben establecer claramente y como mínimo lo siguientes ítems: roles de los intervinientes, información de contactos con responsabilidades, misión, visión, objetivos estratégicos, estructura organizacional un organigrama de la entidad su distribución de dependencias u oficinas en donde se puede ubicar de manera ágil a los responsables que seguramente se convertirán en futuros miembros de los equipos de trabajo donde se presentará interacción (Sinergia laboral).
        p.mb-0 Con lo anterior dispuesto, se puede dar el primer paso fundamental que corresponde a identificar, conocer, incluso ubicar los sitios en donde suceden en el mundo real, aquellos procesos que necesitan ser mejorados, descritos, analizados o propuestos para generar mejoras.
    .row.justify-content-center
      .col-lg-10
        .titulo-sexto.color-acento-contenido
          h5 Figura 6
          p.mb-0 Pasos a tener en cuenta
        figure(data-aos="fade-left")
          img(src='@/assets/curso/img18.svg', style="width: 850px").m-auto
    separador
    #t_4_2
    .titulo-segundo
      h2 4.2 Determinar el equipo de trabajo
    .row.justify-content-center.align-items-center.mb-5(data-aos="fade-left")
      .col-8.col-lg-7.bg-color12
        p Con base en la información recolectada y a la obtención de los requerimientos que permitieron identificar los procesos que necesitan mejorarse, se procede a formar el equipo de trabajo que los identificará, analizará y documentará. Lo ideal es que los responsables que conocen a detalle los procesos conformen el equipo. 
        p.mb-p Por lo tanto, el equipo debería estar integrado por el siguiente grupo humano:
      .col-8.col-lg-5
        figure
          img(src='@/assets/curso/img8.png', style="width: 850px").m-auto
    .row
      .col-lg-6(data-aos="fade-right")
        .tarjeta-avatar-b.mb-5
          .tarjeta-avatar-b__img
            img(src='@/assets/curso/img19.svg' alt='AvatarTop')
          .tarjeta.color-acento-botones
            .p-4
              br
              p El líder del proyecto o el proceso elegido.
              br
      .col-lg-6(data-aos="fade-left")
        .tarjeta-avatar-b.mb-5
          .tarjeta-avatar-b__img
            img(src='@/assets/curso/img20.svg' alt='AvatarTop')
          .tarjeta.color-acento-botones
            .p-4
              br
              p.mb-4 Un alto miembro de la organización que conoce los objetivos estratégicos.
      .col-lg-6(data-aos="fade-right")
        .tarjeta-avatar-b.mb-5
          .tarjeta-avatar-b__img
            img(src='@/assets/curso/img21.svg' alt='AvatarTop')
          .tarjeta.color-acento-botones
            .p-4
              br
              p Los empleados vinculados al proceso.
              br
      .col-lg-6.d-flex(data-aos="fade-left")
        .tarjeta-avatar-b.mb-5
          .tarjeta-avatar-b__img
            img(src='@/assets/curso/img22.svg' alt='AvatarTop')
          .tarjeta.color-acento-botones
            .p-4
              p Los trabajadores de otras áreas que cuentan con la actual experiencia y que desean conocer las mejoras que se llevarán a cabo.
    separador
    #t_4_3
    .titulo-segundo
      h2 4.3 Generar los diagramas de los procesos de negocio
    .row.bg-color6.px-5.mb-5
      .col-12.mb-5
        .row.mb-4(data-aos="fade-up")
          .col-lg-5
            figure
              img(src='@/assets/curso/img23.svg', style="width: 450px").m-auto
          .col-lg-7
            .row
              .col-12.bg-color17
                p.mb-0 Se trata de representar en una secuencia lógica los elementos expresados en la TGS, nombre del proceso el cual debe ser un verbo (fabricar, validar, informar) que permite modelar en un dibujo el proceso de manera rápida, dinámica y sencilla acerca de cómo fluyen las entradas en cada elemento y hacia dónde se deben dirigir sus salidas. En el diagrama es fundamental definir las competencias de cada uno de los integrantes del equipo en cada tarea.
              .col-12.bg-color13
                p.mb-0 El diagrama de procesos es también conocido como diagrama de flujo y en el mundo de los sistemas orientados por procesamiento electrónico de datos obedece a un algoritmo, es decir, al conjunto de pasos lógicos para resolver un problema, es una de las herramientas más útiles para cualquier entidad que quiere gestionar proyectos de todo tipo tanto a nivel interno como externo a ella. Permite abordar la descomposición y conocimiento de los procesos empresariales en orden lógico plasmados dentro de un único documento con sus relaciones, visualizar oportunidades de mejora y, en general para dar importancia y generar control hasta el más mínimo detalle a todos los procesos de una compañía, por pequeños que puedan considerarse. Encontrando con ello, lo siguiente:
    .row.mb-5
      .col-auto.bg-color9
        p.mb-0 a. Diagrama de procesos
    .row.mb-5.align-items-start
      .col-lg-6.mb-4.mb-lg-0
        p Teniendo en cuenta la teoría general de sistemas antes relacionada a un diagrama de procesos, es la forma en la cual  se aplica el enfoque sistémico  para representar de manera gráfica los componentes de las principales actividades que pueden inferirse a su vez como subsistemas que conforman el todo interoperación con orden  lógico guiados por sus interrelaciones. Muestra el flujo secuencial de interacción de las actividades de un proceso a través de símbolos gráficos para proporcionar una mejor visualización del funcionamiento del mismo, ayudando a su entendimiento y haciendo su descripción más didáctica, visual e intuitiva.
        .row
          .col-12.bg-color14
            p.mb-0 Así, el diagrama de procesos se convierte en una herramienta primordial para llevar a cabo el análisis de manera global y ver en qué acciones del flujo de trabajo se pueden introducir métricas, controles o descubrir  oportunidades para mejorar, especialmente pretende orientar los aspectos que permiten como primera medida aumentar la productividad de los empleados, delimitar y asignar las competencias para cada tarea, ver cuellos de botella es decir posibles atascos en el devenir del flujo  y en general para  aclarar el propio flujo de trabajo.
      .col-lg-6
        figure(data-aos="fade-left")
          img(src='@/assets/curso/img9.png', style="width: 650px").m-auto
    .row.mb-5.align-items-center
      .col-lg-5
        figure(data-aos="fade-right")
          img(src='@/assets/curso/img24.svg', style="width: 650px").m-auto
      .col-lg-7.bg-color15
        p En definitiva, es una de las herramientas que más ayuda en la consecución de una mejor gestión empresarial integral, especialmente en aquellas entidades en donde los procesos suelen ser acoplados, de alta complejidad, bastante rígidos o están muy interrelacionados.
        p.mb-0 Teniendo en cuenta las labores a ejecutar vs un tiempo estimado o empleado los diagramas de procesos más utilizados para la gestión de proyectos son el diagrama de Gantt y el diagrama de Pert. Los dos diagramas permiten planificar, simplificar, programar actividades, asignar responsabilidades, pesos por valor de actividad de forma sencilla y  muy visual que facilitan su entendimiento.
    .row.mb-5.align-items-center
      .col-lg-6
        .row.mb-5
          .col-auto.bg-color9
            p.mb-0 b. Elementos de un diagrama de procesos
        p A la hora de construir o representar y dibujar un diagrama de procesos, existe un lenguaje de escritura que se conforma por  una serie de símbolos comúnmente aceptados que han sido establecidos por el estándar ANSI.
        p.mb-0 Estos diagramas están compuestos por elementos gráficos como lo son terminadores, símbolos de procesos, de subprocesos y de decisiones, líneas con flechas y conectores. Los principales elementos están representados de la siguientes formas:
      .col-lg-6
        figure(data-aos="fade-left")
          img(src='@/assets/curso/img25.svg', style="width: 650px").m-auto
    .row.mb-5.align-items-center
      .col-lg-7.mb-4.mb-lg-0
        LineaTiempoD.color-primario
          .row(numero="1" titulo="Procesos o actividades").align-items-center
            .col-lg-8.mb-4.mb-lg-0
              p.text-small Su representación es un rectángulo, se refieren a una acción en un proceso de negocios. Son, posiblemente, los elementos más importantes de un diagrama en cada uno de estos se recomienda de manera detallada aplicar el análisis sistémico en cada actividad, son los que siempre deben aparecer, y por eso deben describirse de forma clara y concisa. Deben ser descritos con una frase única de verbo y sustantivo. Por ejemplo: “Redactar un nuevo informe para presentar a la gerencia de la empresa”.
            .col-lg-4
              figure
                img(src='@/assets/curso/img28.svg', style="width: 180px;").m-auto
          .row(numero="2" titulo="Subprocesos").align-items-center
            .col-lg-8.mb-4.mb-lg-0
              p.text-small Estos se representan con un rectángulo y líneas dobles a cada lado. Deben ser considerados como partes de un proceso padre de mayor complejidad y sirven para determinar funciones más simples al diagrama de flujo incluso reutilizables.
            .col-lg-4
              figure
                img(src='@/assets/curso/img29.svg', style="width: 180px;").m-auto
          .row(numero="3" titulo="Nodos de decisión").align-items-center
            .col-lg-8.mb-4.mb-lg-0
              p.text-small Son los que se representan mediante un triángulo doble (Diamante) y son los que muestran los puntos de decisión a seguir bien sea positivo si se responde a la decisión de “sí” o negativo “no”.
            .col-lg-4
              figure
                img(src='@/assets/curso/img30.svg', style="width: 180px;").m-auto
          .row(numero="4" titulo="Conectores").align-items-center
            .col-lg-8.mb-4.mb-lg-0
              p.text-small Representados por círculos o cuadros conectores que se deben acompañar con la utilización de etiquetas o nombres de caracteres comúnmente alfanuméricos. Aseguran que todos los procesos están conectados de forma lógica y correcta para la correcta navegación entre páginas.
            .col-lg-4
              figure
                img(src='@/assets/curso/img31.svg', style="width: 180px;").m-auto
          .row(numero="5" titulo="Líneas de flecha").align-items-center
            .col-lg-8.mb-4.mb-lg-0
              p.text-small Utilizadas gráficamente para mantener el hilo conductor del flujo de trabajo la coherencia y claridad en un diagrama de procesos. Se pueden dibujar hacia todas las direcciones, normalmente representa el camino por el que fluirá el diagrama.
            .col-lg-4
              figure
                img(src='@/assets/curso/img32.svg', style="width: 80px;").m-auto
      .col-lg-5
        figure(data-aos="fade-left")
          img(src='@/assets/curso/img26.svg', style="width: 650px").m-auto
    .row.mb-5.align-items-center
      .col-lg-5.mb-4.mb-lg-0
        figure(data-aos="fade-right")
          img(src='@/assets/curso/img27.svg', style="width: 650px").m-auto
      .col-lg-7
        LineaTiempoD.color-primario
          .row(numero="6" titulo="Conector para elementos fuera de página").align-items-center
            .col-lg-8.mb-4.mb-lg-0
              p.text-small Permite establecer relaciones para elementos que no están en la misma página.
            .col-lg-4
              figure
                img(src='@/assets/curso/img33.svg', style="width: 180px;").m-auto
          .row(numero="7" titulo="Entrada manual").align-items-center
            .col-lg-8.mb-4.mb-lg-0
              p.text-small Permite representar un acción la cual requiere intervención humana.
            .col-lg-4
              figure
                img(src='@/assets/curso/img34.svg', style="width: 180px;").m-auto
          .row(numero="8" titulo="Almacenamiento").align-items-center
            .col-lg-8.mb-4.mb-lg-0
              p.text-small Representa el sitio en donde normalmente se aloja la información a manera de datos que comúnmente son de carácter estático.
            .col-lg-4
              figure
                img(src='@/assets/curso/img35.svg', style="width: 180px;").m-auto
          .row(numero="9" titulo="Múltiples documentos").align-items-center
            .col-lg-8.mb-4.mb-lg-0
              p.text-small Representa la necesidad de tener en cuenta varios elementos de información o normas, especialmente son considerados como entradas.
            .col-lg-4
              figure
                img(src='@/assets/curso/img36.svg', style="width: 180px;").m-auto
          .row(numero="10" titulo="Terminadores").align-items-center
            .col-lg-8.mb-4.mb-lg-0
              p.text-small Se representan por un rectángulo con esquinas curvas. Son muy importante se consideran como los mayores delimitadores del flujo y deben aparecer siempre al inicio y al final de un diagrama de flujo para indicar la parte del documento o gráfico en donde inicia y en donde finaliza un diagrama.
            .col-lg-4
              figure(data-aos="fade-left")
                img(src='@/assets/curso/img37.svg', style="width: 280px;").m-auto
    .row.mb-5.align-items-center
      .row.mb-5
          .col-auto.bg-color9
            p.mb-0 c. Un buen diagrama de procesos
      .col-lg-6
        p Al momento de crear un diagrama de procesos se recomienda guiarse por al menos cumplir los siguientes pasos:
        ol.lista-ol--cuadro.lista-ol
          li 
            .lista-ol--cuadro__vineta
              span(style="color: #000000") 1
            |
            p #[b Ubicar o según sea el caso abstraer los componentes del proceso]: en este paso se aclaran cuáles son los parámetros de entrada al proceso y sus salidas, así como las actividades que se desarrollan en el mismo.
          li 
            .lista-ol--cuadro__vineta
              span(style="color: #000000") 2
            |
            p #[b Ordenar de manera lógica las actividades]: dado que el diagrama de procesos es un flujo, es necesario ordenar las actividades para saber cuál es su secuencia.
          li 
            .lista-ol--cuadro__vineta
              span(style="color: #000000") 3
            |
            p Elegir los símbolos adecuados conforme el tipo de tarea para que cualquier usuario pueda diferenciar los distintos elementos que forman el diagrama.
          li 
            .lista-ol--cuadro__vineta
              span(style="color: #000000") 4
            |
            p Hacer la conexión y relación entre las actividades, para lo cual se utilizan flechas y líneas de puntos o continuas.
          li 
            .lista-ol--cuadro__vineta
              span(style="color: #000000") 5
            |
            p Representar el comienzo y el final de cada proceso. Aunque pueda parecer trivial e irrelevante, lo cierto es que este es un punto muy importante para establecer los límites de cada proceso u actividad de cara a los propietarios de los procesos, gerentes y supervisores.
          li 
            .lista-ol--cuadro__vineta
              span(style="color: #000000") 6
            |
            p Validar, socializar con los integrantes del equipo y revisar el diagrama de procesos para asegurarse que su representación obedece a un gráfico acorde con lo que se quiere reflejar.
      .col-lg-6
        figure(data-aos="fade-left")
          img(src='@/assets/curso/img38.svg', style="width: 500px").m-auto
    .row.align-items-center
      .row.mb-5
          .col-auto.bg-color9
            p.mb-0 d. Dividendos de los  diagramas de procesos
          .col-12.mt-5
            p Utilizar un diagrama de flujo le aporta los siguientes beneficios a tu empresa:
      .col-lg-6
        .col-11
          .tarjeta-avatar-b.mb-5
            .tarjeta-avatar-b__img
              img(src='@/assets/curso/img39.svg' alt='AvatarTop')
            .tarjeta.color-acento-contenido
              .p-4
                p Permite obtener la primera aproximación desde el punto de vista algorítmico de cada actividad  o proceso así como también puntos de interoperabilidad.
        .col-11
          .tarjeta-avatar-b.mb-5
            .tarjeta-avatar-b__img
              img(src='@/assets/curso/img40.svg' alt='AvatarTop')
            .tarjeta.color-acento-contenido
              .p-4
                p Favorece la comprensión del proceso que trata de simular. Dado que normalmente están representadas a través de algún elemento gráfico y sus nodos están interconectados entre sí, gracias a un diagrama de este tipo es más fácil saber cuáles son las tareas que se dibujan, así como sus relaciones de dependencia.
        .col-11
          .tarjeta-avatar-b.mb-5
            .tarjeta-avatar-b__img
              img(src='@/assets/curso/img41.svg' alt='AvatarTop')
            .tarjeta.color-acento-contenido
              .p-4
                p Permite identificar de una forma rápida los inconvenientes y dónde se producen. Así, es más fácil saber dónde se crean o se presentan posibles cuellos de botella, las responsabilidades de cada área y los puntos de decisión. Asimismo, permite analizar de una forma mucho más exhaustiva el problema, lo cual hace posible que aparezcan nuevas soluciones y alternativas.
        .col-11
          .tarjeta-avatar-b.mb-5
            .tarjeta-avatar-b__img
              img(src='@/assets/curso/img42.svg' alt='AvatarTop')
            .tarjeta.color-acento-contenido
              .p-4
                p Permite definir claramente las fronteras de cada proceso, ya que todas las tareas están lo suficientemente delimitadas, incluso aunque estén interrelacionadas. De esta manera, se puede saber qué tareas suponen un mayor valor añadido y cuáles no aportan tanto.
        .col-11
          .tarjeta-avatar-b.mb-5
            .tarjeta-avatar-b__img
              img(src='@/assets/curso/img43.svg' alt='AvatarTop')
            .tarjeta.color-acento-contenido
              .p-4
                p También es una buena herramienta de capacitación, instrucción y formación para nuevos empleados que se integran dentro de la empresa facilitando su proceso de adaptación a la organización.
      .col-lg-6
        figure(data-aos="fade-left")
          img(src='@/assets/curso/img44.svg', style="width: 900px").m-auto
    separador
    #t_4_4
    .titulo-segundo
      h2 4.4 Realizar un diagnóstico de cada proceso
    figure.mb-5(data-aos="fade-right")
      img(src='@/assets/curso/img10.png').m-auto
    p Esta labor permite a las empresas detectar por medio la implementación de estrategias para detectar los problemas de funcionamiento y deficiencias. Estas estrategias son:
    ul.lista-ul.ms-3.mb-0
      li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
        i.fab.fa-buffer(style="color:#039BE5;")
        | Entender las causas propias que maneja los casos de cada proceso.
      li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
        i.fab.fa-buffer(style="color:#039BE5;")
        | Ejecutar simulacros de relevamiento de procesos unido a sus responsables.
      li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
        i.fab.fa-buffer(style="color:#039BE5;")
        | Apoyarse en herramientas de software para registrar resultados, controles, métricas, análisis de tiempos, costos y materias primas.
    separador
    #t_4_5
    .titulo-segundo
      h2 4.5 Puntos de mejora
    .row.align-items-center(data-aos="fade-left")
      .col-lg-5
        figure
          img(src='@/assets/curso/img11.png', style="width: 650px").m-auto
      .col-lg-7.bg-color15
        p.mb-0 Luego del diagnóstico de la situación actual, es importante construir un informe que dé a conocer el estado anterior y el estado actual hacia dónde se quiere llegar con las mejoras. En este informe se recomienda de manera obligatoria el poder relacionar los alcances de las soluciones unidos en forma transversal con los objetivos estratégicos de la organización.
    separador
    #t_4_6
    .titulo-segundo.mb-0
      h2 4.6 Nuevo proceso mejorado
    figure.img-style2(data-aos="fade-up")
      img(src='@/assets/curso/img12.png').m-auto
    .row.bg-color6.px-5
      .col-12.py-5
        p.mt-5 Los resultados obtenidos de la aplicación de cada uno de los pasos anteriores se deben compilar y almacenar para convertirse en información de salida con el objetivo de llevar trazabilidad. Al realizar encuentros o reuniones de análisis de dicha información, se genera el diseño de un nuevo proceso, el cual estará destinado al logro de los objetivos estratégicos de la compañía y así llegar a un estadio de mayor eficiencia y eficacia.
        p.mb-5 Ejemplo de diagrama:
        figure(data-aos="fade-left")
          img(src='@/assets/curso/img45.svg', style="width: 650px").m-auto
    separador
    #t_4_7
    .titulo-segundo
      h2 4.7 Caso de estudio
    p.mb-5 Identificar el conjunto de elementos que intervienen en un sistema de compras online de una fábrica aplicando la TGS para finalmente proponer las actividades representadas en un diagrama de procesos.
    .row.mb-5.justify-content-center
      .col-lg-10
        .titulo-sexto.color-acento-contenido
          h5 Tabla 1
          p.mb-0 Sistema de compras en línea
        .tabla-b.color-acento-contenido.mb-5
          table
            caption Nota. SENA (2021).
            tr(style="background-color: #FFA726")
              th.text-white.text-center Entradas
              th.text-white.text-center(style="border-left: 1px solid #AFAFAF") Subproceso o actividad
              th.text-white.text-center(style="border-left: 1px solid #AFAFAF") Salidas
            tr
              td
                p Datos del solicitante (Nombres, apellidos, identificación, dirección de contacto).
                p.mb-0 Producto que comprar (Valor, Cantidad).
              td(style="border-left: 1px solid #AFAFAF")
                p.mb-0 Recepción de solicitud de compra.
              td(style="border-left: 1px solid #AFAFAF")
                p Número único de identificación de la compra.
                p Factura.
                p.mb-0 Envío.
            tr
              td
                p.mb-0 Número único de identificación de la compra.
              td(style="border-left: 1px solid #AFAFAF")
                p.mb-0 Almacén
              td(style="border-left: 1px solid #AFAFAF")
                p.mb-0 Producto.
            tr
              td
                p Insumos
                p.mb-0 Mano de obra
              td(style="border-left: 1px solid #AFAFAF")
                p.mb-0 Fábrica
              td(style="border-left: 1px solid #AFAFAF")
                p.mb-0 Producto elaborado.
            tr
              td
                p.mb-0 Facturas
              td(style="border-left: 1px solid #AFAFAF")
                p.mb-0 Contabilidad
              td(style="border-left: 1px solid #AFAFAF")
                p.mb-0 Informes contables.
    .row.mb-5.align-items-center
      .col-lg-4
        figure(data-aos="fade-right")
          img(src='@/assets/curso/img46.svg', style="width: 650px").m-auto
      .col-lg-8
        p Puesto que el sistema de compras en línea no intercambia elementos de información con el medio ambiente que lo rodea se considera un sistema cerrado, de lo anterior se concluye:
        TabsC.color-primario
          .py-3.py-md-4(titulo="Se pueden inferir las siguiente relaciones").bg-color16
            .row
              .col-12
                ul.lista-ul.ms-3.mb-0
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Usuario solicitante contra el proceso de solicitud de compra en donde un usuario puede generar una o muchas solicitudes de compras.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | El almacén maneja el inventario de productos.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | La fábrica provee de muchos productos al almacén.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | El almacén promociona el producto para la solicitud.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | El usuario realiza el pago del producto.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Contabilidad registra la factura de compra generada por la solicitud.
          .py-3.py-md-4(titulo="Actores Responsables").bg-color16
            .row
              .col-12
                ul.lista-ul.ms-3.mb-0
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Usuario que genera la solicitud.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Jefe de ventas.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Administrador del sistema online.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Jefe de contabilidad.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Jefe del control de operaciones de fábrica.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Jefe de inventarios.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Empleados de la fábrica.
                  li(style="border: 0px; padding-bottom: 10px; margin-bottom: 0px;")
                    i.fab.fa-buffer(style="color:#039BE5;")
                    | Gerencia de área.
    p.mb-5 Ejemplo de un diagrama de procesos:
    .row.mb-5.justify-content-center
      .col-lg-10
        figure
          img(src='@/assets/curso/img47.svg', style="width: 10  50px").m-auto
    .row
      .col-lg-auto
        a.anexo(:href="obtenerLink('/downloads/Anexo1.pdf')" target="_blank")
          .anexo__icono
            img(src="@/assets/template/icono-pdf.svg")
          .anexo__texto
            p #[b Anexo]. Ejemplo diagrama de procesos

</template>

<script>
export default {
  name: 'Tema4',
  components: {},
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass" scoped></style>
